export interface Condition {
  id: string;
  type: ConditionType;
  operator?: string;
  value?: any;
  values?: any[];
  startDate?: string;
  endDate?: string;
  untilPresent?: boolean;
  minValue?: number;
  maxValue?: number;
  countryId?: number;
}

export type ConditionType = 
  | 'sex'
  | 'averageTicket'
  | 'channel'
  | 'age'
  | 'brands'
  | 'categories'
  | 'level'
  | 'purchaseCount'
  | 'purchasesInPeriod'
  | 'purchasesInDateRange'
  | 'totalSpent'
  | 'birthday'
  | 'registrationDate'
  | 'city';

export interface ConditionConfig {
  type: ConditionType;
  label: string;
  operators?: string[];
  valueType: 'select' | 'number' | 'date' | 'dateRange' | 'numberRange' | 'multiSelect' | 'purchasesInPeriod' | 'purchasesInDateRange' | 'city';
  options?: { value: any; label: string }[];
  placeholder?: string;
  min?: number;
  max?: number;
}

export const CONDITION_CONFIGS: Record<ConditionType, ConditionConfig> = {
  sex: {
    type: 'sex',
    label: 'Sexo',
    operators: ['Es'],
    valueType: 'select',
    options: [],
    placeholder: 'Seleccionar sexo'
  },
  averageTicket: {
    type: 'averageTicket',
    label: 'Ticket promedio',
    valueType: 'numberRange',
    placeholder: 'Rango de ticket',
    min: 0
  },
  channel: {
    type: 'channel',
    label: 'Canal',
    valueType: 'multiSelect',
    options: [],
    placeholder: 'Seleccionar canales'
  },
  age: {
    type: 'age',
    label: 'Edad',
    valueType: 'numberRange',
    placeholder: 'Rango de edad',
    min: 0,
    max: 120
  },
  brands: {
    type: 'brands',
    label: 'Marcas',
    valueType: 'multiSelect',
    options: [],
    placeholder: 'Seleccionar marcas'
  },
  categories: {
    type: 'categories',
    label: 'Categorías',
    valueType: 'multiSelect',
    options: [],
    placeholder: 'Seleccionar categorías'
  },
  level: {
    type: 'level',
    label: 'Nivel',
    valueType: 'select',
    options: [],
    placeholder: 'Seleccionar nivel'
  },
  purchaseCount: {
    type: 'purchaseCount',
    label: 'Cantidad de compras',
    valueType: 'numberRange',
    placeholder: 'Rango de compras',
    min: 0
  },
  purchasesInPeriod: {
    type: 'purchasesInPeriod',
    label: 'Compras en los últimos X días',
    valueType: 'purchasesInPeriod',
    placeholder: 'Compras en período'
  },
  purchasesInDateRange: {
    type: 'purchasesInDateRange',
    label: 'Compras en el período',
    valueType: 'purchasesInDateRange',
    placeholder: 'Compras en período'
  },
  totalSpent: {
    type: 'totalSpent',
    label: 'Total gastado',
    valueType: 'numberRange',
    placeholder: 'Rango de total gastado',
    min: 0
  },
  birthday: {
    type: 'birthday',
    label: 'Cumpleaños entre',
    valueType: 'dateRange',
    placeholder: 'Rango de cumpleaños'
  },
  registrationDate: {
    type: 'registrationDate',
    label: 'Fecha de registro',
    valueType: 'dateRange',
    placeholder: 'Rango de registro'
  },
  city: {
    type: 'city',
    label: 'Ciudad',
    valueType: 'city',
    placeholder: 'Seleccionar ciudad'
  }
};
